// @flow

import styled from 'styled-components';
import React, { type Node } from 'react';

import { Empty } from '@tectonics/components';
import { type Country } from '@tectonics/prs/country';
import { getBillingDescriptor } from '@tectonics/prs/incoming-payment/details';
import { usePendingIncomingPayment, getDetails, getCountry } from '@tectonics/prs/incoming-payment';

export function BillingDescriptor(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const details = getDetails(incomingPayment);

  if (!details) {
    return <Empty />;
  }

  const billingDescriptor = getBillingDescriptor(details);
  const country = getCountry(incomingPayment);

  return (
    <DescriptionList>
      <Term>
        <TermBillingMessage country={country} />
      </Term>
      <Description>{billingDescriptor}</Description>
    </DescriptionList>
  );
}

type TermBillingMessageProps = {|
  country: Country,
|};

function TermBillingMessage({ country }: TermBillingMessageProps): Node {
  switch (country) {
    case 'br':
      return 'Na sua fatura irá aparecer';

    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'uy':
    case 'py':
    case 'pa':
    case 'cr':
    case 'sv':
    case 'gt':
    case 'do':
      return 'En el estado de cuenta aparecerá la descripción';
    case 'ke':
    case 'ng':
    case 'za':
    case 'eg':
    case 'in':
      return 'In your credit card bill';

    default:
      throw new Error(`BillingDescriptor - TermBillingMessage - There is no message for country "${country}".`);
  }
}

const Term = styled.dt`
  ::after {
    content: ':';
  }
`;

const Description = styled.dt`
  font-weight: bold;
`;

const DescriptionList = styled.dl`
  font-size: 1.15em;
  padding: 0.5em;

  ${Term}, ${Description} {
    margin: 1em auto;
  }
`;
